// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"LP-z","inlineTitle":"MP-z","sponsoredAdsWrapper":"NP-z","marketplaceRecosWrapper":"OP-z"};